import { clear } from '../../../../helpers/compact';
import { CommonSliceType } from '../../../../types/slice';
import { toSize } from '../../mapping/size';
import { image } from '../../partials/image';

/**
 * Transform items to list of processed images
 * @param items
 * @returns list of processed images
 */

export const coverCarousel = ({ primary, items }) => {
  const content = items?.map(image).filter(Boolean);
  if (content?.length >= 3) {
    return clear({
      type: CommonSliceType.COVER_CAROUSEL,
      blocks: content,
      size: toSize(primary?.size),
    });
  }
};
